import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { rejectPathwayScormApproval } from '../../../api/pathwayScormApprovals';
import { PATHWAY_SCORM_APPROVALS_KEY } from './useGetPathwayScormApprovalsQuery';

const useRejectPathwayScormMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, rejectionReason }) =>
      rejectPathwayScormApproval(id, rejectionReason),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(PATHWAY_SCORM_APPROVALS_KEY);
        message.success('Pathway SCORM changes rejected');
      },
      onError: error => {
        const errorMessage =
          error?.response?.data?.error?.user_message ||
          error?.response?.data?.error ||
          'Failed to reject SCORM request';
        message.error(
          typeof errorMessage === 'string'
            ? errorMessage
            : 'Failed to reject SCORM request'
        );
      },
    }
  );
};

export default useRejectPathwayScormMutation;
